<template>
  <v-dialog
    v-model="_active"
    @click:outside="_setActive(false)"
    :fullscreen="this.$vuetify.breakpoint.smAndDown"
  >
    <v-card :style="modalStyle">
      <v-card color="primary" class="mb-4" tile v-if="showMobileView">
        <v-card-title class="py-0 white--text" color="primary">
          <v-container>
            <v-row>
              <v-spacer cols="2" />
              <v-col cols="8" class="pb-0">
                <v-card-text class="text-center font-weight-bold pb-0"
                  >FILTER RESULTS</v-card-text
                >
              </v-col>
              <v-col cols="2" class="pb-0 pt-5">
                <v-btn color="white" text @click="_setActive(false)">
                  <v-icon xl>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
      </v-card>
      <div
        v-if="!showMobileView"
        style="height:15vh;"
        class="d-flex justify-space-around"
      >
        <div class="pt-8" style="width:40%">
          <v-btn
            color="black"
            style="color:white; width:100%; font-size:18px;"
            @click="_setActive(false)"
            class="elevation-0"
            id="filter-modal-close-button"
          >
            <v-icon>mdi-chevron-left</v-icon>Close
          </v-btn>
        </div>
        <div class="pt-8" style="width:40%">
          <v-btn
            text
            style="width:100%; font-size:18px;"
            @click="clear()"
            id="filter-modal-clear-button"
            >Clear</v-btn
          >
        </div>
      </div>
      <component :is="$route.name" />
      <div v-if="showMobileView">
        <v-row>
          <v-spacer />
          <v-col>
            <v-btn
              color="primary"
              class="mb-2 font-weight-bold"
              :class="textStyle"
              width="150"
              @click="_setActive(false)"
              >Apply</v-btn
            >
            <v-btn class="mb-2" text width="150" @click="clear"
              >Clear Filters</v-btn
            >
          </v-col>
          <v-spacer />
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import StoringFilters from '@/mixins/StoringFilters';
import { MobileView } from '@/mixins';
import FilterParams from '@/mixins/FilterParams';
import Home from '@/components/filter/Home';
import Groups from '@/components/filter/Groups';
import Screens from '@/components/filter/Screens';
import Devices from '@/components/filter/Devices';
import Reconciliation from '@/components/filter/Reconciliation';
import Reports from '@/components/filter/Reports';
import Keys from '@/components/filter/Keys';
import Users from '@/components/filter/Users';

export default {
  mixins: [StoringFilters, MobileView, FilterParams],
  components: {
    Home,
    Groups,
    Screens,
    Devices,
    Reconciliation,
    Reports,
    Keys,
    Users,
  },
  methods: {
    ...mapMutations({
      _setActive: 'filters/setFilters',
    }),
    ...mapActions({
      _getHomeData: 'home/getHomePageData',
      _getKeyData: 'digitalKeys/acquireData',
      _getGroupData: 'groups/acquireGroups',
      getDevices: 'maps/getDeviceLocations',
    }),
  },
  computed: {
    ...mapGetters({
      _active: 'filters/getFilters',
      _clearedParams: 'filters/getClearedFilterParams',
      currentClient: 'account/getCurrentClient',
    }),
    modalStyle() {
      if (!this.showMobileView) {
        return 'overflow-x:hidden; overflow-y:auto; position: absolute; top:65px; left:0; width: 40%; min-height:100%;';
      }
      return 'overflow-x: hidden;';
    },
  },
  watch: {},
  mounted() {},
};
</script>
